import styled from "styled-components";
import { lg, sm } from "../../../BreakPoints";

export const Page = styled.main`
  min-height: 100vh;
  padding: 3.9rem 1.2rem 1.6rem;
  background: radial-gradient(circle at 8% 0%, rgba(59, 99, 247, 0.16), transparent 30%),
    radial-gradient(circle at 88% 16%, rgba(46, 196, 182, 0.14), transparent 28%), var(--ice-blue);
`;

export const Content = styled.section`
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  gap: 1rem;

  ${lg({
    gridTemplateColumns: "1fr",
  })}
`;

export const Intro = styled.article`
  border-radius: 0.7rem;
  padding: 1rem;
  background: linear-gradient(135deg, var(--deep-navy), var(--deep-navy-soft));
  color: var(--surface-white);
  display: grid;
  gap: 0.85rem;
`;

export const IntroTitle = styled.h1`
  font-size: clamp(1.6rem, 3.6vw, 2.2rem);
  line-height: 1.15;
`;

export const IntroText = styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
  color: rgba(240, 245, 255, 0.92);
`;

export const BulletList = styled.ul`
  margin: 0;
  padding-left: 1rem;
  display: grid;
  gap: 0.38rem;
`;

export const Bullet = styled.li`
  font-size: 0.86rem;
  color: rgba(240, 245, 255, 0.88);
`;

export const FormCard = styled.article`
  border-radius: 0.7rem;
  padding: 1rem;
  background: var(--surface-white);
  border: 1px solid var(--line-mid);
  box-shadow: 0 8px 16px rgba(14, 46, 108, 0.08);

  ${sm({
    padding: "1rem 0.85rem",
  })}
`;

export const Form = styled.form`
  display: grid;
  gap: 0.7rem;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;

  ${sm({
    gridTemplateColumns: "1fr",
  })}
`;

export const Title = styled.h2`
  color: var(--deep-navy);
  font-size: 1.2rem;
`;

export const Description = styled.p`
  margin-top: 0.2rem;
  font-size: 0.85rem;
  line-height: 1.5;
  color: var(--text-muted);
`;

export const Input = styled.input`
  width: 100%;
  border: 1px solid var(--line-mid);
  border-radius: 0.62rem;
  padding: 0.72rem 0.82rem;
  outline: none;
  font-size: 0.9rem;
  background: rgba(255, 255, 255, 0.95);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: var(--slate);
  }

  &:focus {
    border-color: var(--brand-blue);
    box-shadow: 0 0 0 4px rgba(59, 99, 247, 0.12);
  }
`;

export const Select = styled.select`
  width: 100%;
  border: 1px solid var(--line-mid);
  border-radius: 0.62rem;
  padding: 0.72rem 0.82rem;
  outline: none;
  font-size: 0.9rem;
  background: rgba(255, 255, 255, 0.95);
  color: var(--deep-navy);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: var(--brand-blue);
    box-shadow: 0 0 0 4px rgba(59, 99, 247, 0.12);
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 130px;
  border: 1px solid var(--line-mid);
  border-radius: 0.62rem;
  padding: 0.72rem 0.82rem;
  outline: none;
  resize: vertical;
  font-size: 0.9rem;
  font-family: var(--font-body);
  background: rgba(255, 255, 255, 0.95);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: var(--slate);
  }

  &:focus {
    border-color: var(--brand-blue);
    box-shadow: 0 0 0 4px rgba(59, 99, 247, 0.12);
  }
`;

export const Button = styled.button`
  border: none;
  border-radius: 0.72rem;
  padding: 0.76rem 1rem;
  background: var(--brand-blue);
  color: var(--surface-white);
  font-family: var(--font-display);
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  box-shadow: 0 14px 24px rgba(18, 72, 179, 0.25);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 18px 28px rgba(18, 72, 179, 0.32);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const FooterText = styled.p`
  margin-top: 0.2rem;
  color: var(--text-muted);
  font-size: 0.78rem;
  line-height: 1.5;
`;
